// Icon and accent per mission key, matching skmob's mission_style.dart.
import { Bars, Bolt, Calendar, Compass, Flame, Heart, List, Music, Person, Play, Sparkle, Star, Target, TrendUp, Wave } from "../../pages/Leaderboard/analytics/icons";

const YELLOW = "#FFEE20";
const CYAN = "#00C3FD";
const RED = "#FF4D6D";
const BLUE = "#3B82F6";
const PURPLE = "#9B5CFF";
const ORANGE = "#FF8A1F";
const GREEN = "#2CF488";
const PINK = "#FF1CBE";

const STYLES = {
  listen5Today: [Play, YELLOW],
  watch2Live: [Wave, CYAN],
  support3Emerging: [Heart, RED],
  discover5Songs: [Music, BLUE],
  completeFullSet: [List, PURPLE],
  genrePlaylist: [Target, ORANGE],
  bringAFriend: [Person, CYAN],
  attend3Consecutive: [Bolt, PURPLE],
  helpMilestone: [Heart, ORANGE],
  first100Fans: [Star, YELLOW],
  curate3Weekly: [Sparkle, GREEN],
  build10Playlist: [List, PURPLE],
  curate5Emerging: [Compass, GREEN],
  playlist50Streams: [TrendUp, PINK],
  playlist10Favorites: [Person, ORANGE],
  goLiveWeekly: [Wave, RED],
  stream4Weeks: [Calendar, CYAN],
  draw10Viewers: [Person, BLUE],
  release3Songs: [Music, YELLOW],
  thank3Fans: [Heart, PINK],
  reach100Followers: [TrendUp, GREEN],
  playlisted25: [Bars, PURPLE],
};

export function missionStyle(key) {
  const [Icon, color] = STYLES[key] || [Target, YELLOW];
  return { Icon, color };
}

// "1d left" for daily missions, "Nd left" for weekly ones, null for once.
export function missionTimeLeft(mission, now = new Date()) {
  const period = mission?.period || "once";
  if (period === "daily") return "1d left";
  if (period === "weekly") {
    const weekday = (now.getUTCDay() + 6) % 7; // Monday = 0
    return `${7 - weekday}d left`;
  }
  return null;
}

export { Flame };
